// @i18n-ignore-all
export default [
  {
    point: '@@menus',
    onload: () => [{ id: 'enterprise-manage', weight: 4, label: '企业管理' }]
  }
]
